<template>
  <div class="ic-form__bank">
    <h3>Rachunek bankowy</h3>

    <div class="row">
      <div class="col-md-12 mbm">{{$t(introtext)}}</div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <IcFormRowWrapper id="transferType" :labelWidth="0" :controlWidth="8">
          <IcRadioGroup id="transferType" :options="transferTypes" v-model="data.isForeign"/>
        </IcFormRowWrapper>
      </div>
    </div>

    <div class="row" v-if="data.isForeign == 0">
      <div class="col-md-12">
        <IcFormRowWrapper
          id="iban"
          name="bank.iban"
          :label="$t('label_bank_account')"
          :aria="$t('aria_required')"
          :labelWidth="4"
          :controlWidth="8"
          :showSingleError="true"
        >
          <template slot-scope="{validator}">
            <IcInputBankAccount
              id="bankAccount"
              v-model="data.iban"
              @input="emitInput(data,validator)"
            ></IcInputBankAccount>
          </template>
        </IcFormRowWrapper>
      </div>
    </div>

    <div v-if="data.isForeign == 1">
      <div class="row">
        <div class="col-md-12 mbm">{{$t('form_bank_introtext_foreign')}}</div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <IcFormRowWrapper
            rowElement="IcFormRow"
            id="iban"
            name="bank.iban"
            :label="$t('label_bank_account')"
            :aria="$t('aria_required')"
            :labelWidth="4"
            :controlWidth="8"
            :showSingleError="true"
          >
            <template slot-scope="{validator}">
              <IcInputBankAccount
                id="bankAccount"
                v-model="data.iban"
                @input="emitInput(data,validator)"
                :showPrefix="true"
              ></IcInputBankAccount>
            </template>
          </IcFormRowWrapper>
        </div>
        <div class="col-md-6">
          <IcFormRowWrapper
            rowElement="IcFormRow"
            id="accountOwner"
            name="bank.accountOwner"
            :label="$t('label_bank_account_owner')"
            :aria="$t('aria_required')"
            :labelWidth="4"
            :controlWidth="8"
            :showSingleError="true"
          >
            <template slot-scope="{validator}">
              <IcInput
                id="accountOwner"
                v-model="data.accountOwner"
                @input="emitInput(data,validator)"
              ></IcInput>
            </template>
          </IcFormRowWrapper>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <IcFormRowWrapper
            rowElement="IcFormRow"
            id="swift"
            name="bank.swift"
            :label="$t('label_bank_swift')"
            :aria="$t('aria_required')"
            :labelWidth="4"
            :controlWidth="8"
            :showSingleError="true"
          >
            <template slot-scope="{validator}">
              <IcInputBankSwift id="swift" v-model="data.swift" @input="emitInput(data,validator)"></IcInputBankSwift>
            </template>
          </IcFormRowWrapper>
        </div>
        <div class="col-md-9">
          <IcFormRowWrapper
            rowElement="IcFormRow"
            id="name"
            name="bank.name"
            :label="$t('label_bank_name')"
            :aria="$t('aria_required')"
            :labelWidth="4"
            :controlWidth="8"
            :showSingleError="true"
          >
            <template slot-scope="{validator}">
              <IcInput id="name" v-model="data.name" @input="emitInput(data,validator)"></IcInput>
            </template>
          </IcFormRowWrapper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IcInput from "@/components/ic-common/form/controls/Input";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import IcInputBankAccount from "@/components/ic-common/form/controls/InputBankAccount";
import IcInputBankSwift from "@/components/ic-common/form/controls/InputBankSwift";
import { Bank } from "../Model/Bank";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactBank",
  props: {
    value: {
      type: Object,
      default: new Bank()
    },
    introtext: {
      default: "form_bank_introtext"
    }
  },
  data() {
    return {
      transferTypes: [
        { id: 0, name: "Przelew krajowy" },
        { id: 1, name: "Przelew zagraniczny" }
      ],
      data: Object.assign({}, new Bank(), this.value)
    };
  },
  // watch: {
  //   data: {
  //     deep: true,
  //     handler: function(newValue, oldValue) {
  //       this.$emit("input", this.data);
  //     }
  //   }
  // },
  methods: {
    emitInput
  },
  components: {
    IcInput,
    IcInputBankAccount,
    IcInputBankSwift,
    IcRadioGroup
  }
};
</script>

<style>
</style>
